import store from "@/store";
import router from "@/router";
import nativeHandlerService from "@/services/nativeHandler";
import userInfoService from "@/services/userInfo";

// 今すぐ使う(type: "using")→ 遷移先でQR読み取りあり
// 予約する(type: "booking") → 遷移先でQR読み取りなし
export const goToSelectCycle = async (park, type) => {
  // クレカ情報チェック
  if (await userInfoService.checkCreditCard()) {
    if (store.getters["common/device"] == "BROWSER") {
      router.push({
        name: "DbsSelectCycle",
        params: {
          park_id: park.Station.code.split(".")[1],
        },
        query: {
          type: type,
        },
      });
    } else {
      if (type == "using") {
        nativeHandlerService.ncDbsNowUseURL(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}dbs/select-cycle/${park.Station.code.split(".")[1]}?type=${type}`
        );
      } else {
        nativeHandlerService.ncDbsOpenWebview(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}dbs/select-cycle/${park.Station.code.split(".")[1]}?type=${type}`
        );
      }
    }
  } else {
    nativeHandlerService.returnNativeAppToCreditCardPage()
  }
};
